import { Component, OnInit } from '@angular/core';
import { DynamicDialogConfig, DynamicDialogRef } from 'primeng/dynamicdialog';

@Component({
  selector: 'app-message-modal',
  templateUrl: './message-modal.component.html',
  styleUrls: ['./message-modal.component.scss']
})
export class MessageModalComponent implements OnInit {
  tip = '';
  messageData: any;

  constructor(public data: DynamicDialogConfig,
    public dialogRef: DynamicDialogRef) {
    if (data) {
      this.messageData = data.data;
    }
  }

  ngOnInit(): any {

  }

  close(): any {
    this.dialogRef.close();
  }

  returnChoiceAndClose(choice: string): any {
    this.dialogRef.close(choice);
  }
}
